(() => {
  if (customElements.get('nasaem-cart-note')) return;

  // Keep the current draft outside the element: cart updates replace its HTML.
  let draft = null;
  let saved = null;
  let edited = false;
  let timer;
  let pending;
  let state = 'idle';
  const messages = {
    idle: 'تُرفق ملاحظتك مع الطلب',
    saving: 'جارٍ حفظ الملاحظة…',
    saved: 'تم حفظ الملاحظة ✓',
    error: 'تعذّر الحفظ، حاول مرة أخرى',
  };

  function render() {
    document.querySelectorAll('nasaem-cart-note').forEach((element) => {
      const input = element.querySelector('textarea');
      if (input.value !== draft) input.value = draft;
      element.dataset.state = state;
      element.querySelector('[role="status"]').textContent = messages[state];
      element.querySelector('[data-note-retry]').hidden = state !== 'error';
    });
  }

  function save() {
    clearTimeout(timer);
    if (pending) return pending;
    if (draft === saved) {
      state = edited ? 'saved' : 'idle';
      render();
      return Promise.resolve(true);
    }
    state = 'saving';
    render();
    // Serialize writes so an older note can never finish after a newer one.
    pending = (async () => {
      try {
        while (draft !== saved) {
          const note = draft;
          const response = await fetch(window.routes?.cart_update_url || `${window.Shopify.routes.root}cart/update.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note }),
          });
          const cart = await response.json();
          if (!response.ok || cart.errors || (cart.note || '') !== note) throw new Error('Note was not saved');
          saved = note;
        }
        state = 'saved';
        return true;
      } catch {
        state = 'error';
        return false;
      } finally {
        pending = null;
        render();
      }
    })();
    return pending;
  }

  customElements.define('nasaem-cart-note', class extends HTMLElement {
    connectedCallback() {
      if (!edited) draft = saved = this.querySelector('textarea').value;
      render();
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('input', (event) => {
        if (event.target.tagName !== 'TEXTAREA') return;
        draft = event.target.value;
        edited = true;
        state = 'saving';
        render();
        clearTimeout(timer);
        timer = setTimeout(save, 400);
      });
      this.addEventListener('change', (event) => {
        // CartItems treats every bubbling change as a quantity change.
        event.stopPropagation();
        save();
      });
      this.querySelector('[data-note-retry]').addEventListener('click', save);
    }
  });

  // Native form association also includes the latest note when JS is unavailable.
  // With JS, wait for any older autosave before allowing the checkout POST.
  let checkingOut = false;
  let allowSubmit = false;
  document.addEventListener('submit', async (event) => {
    if (event.target.id !== 'CartDrawer-Form' || allowSubmit || !edited) return;
    if (!pending && draft === saved) return;
    event.preventDefault();
    if (checkingOut) return;
    checkingOut = true;
    const button = document.getElementById('CartDrawer-Checkout');
    if (button) button.disabled = true;
    const ok = await save();
    checkingOut = false;
    const currentButton = document.getElementById('CartDrawer-Checkout');
    if (currentButton) currentButton.disabled = false;
    if (ok) {
      allowSubmit = true;
      document.getElementById('CartDrawer-Form')?.requestSubmit(currentButton || undefined);
      allowSubmit = false;
    } else {
      document.getElementById('CartDrawer-Note')?.focus();
    }
  });
})();
